import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectNestedErrorExists } from 'services/error/selectors';

// Types
import { Namespace } from 'types';
import { AppState } from 'services/types';

export interface OwnProps {
    namespace: Namespace;
    uuid: string;
    children: React.ReactElement;
}

interface ConnectedProps {
    nestedErrorExists?: any;
}

type Props = OwnProps & ConnectedProps;

export class NestedErrorExistsGate extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { children, nestedErrorExists } = this.props;
        if (!nestedErrorExists) {
            return null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    nestedErrorExists: makeSelectNestedErrorExists()
});

export default connect(mapStateToProps)(NestedErrorExistsGate);
